let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6aUfU")).then(() => parcelRequire('it8QE'));